// extracted by mini-css-extract-plugin
export default {"notesWrapper":"Notes_notesWrapper__jaDTc","notesBody":"Notes_notesBody__EWgz+","addFile":"Notes_addFile__AGNSB"};